import React, { useEffect, useState } from "react";
import {
  Loader,
  CommonHeader,
  ErrorSuccessModal,
} from "../../../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  AssignedClientsToUserType,
  ClientType,
  UserType,
} from "../../../../redux/auth/authTypes";
import { Input } from "reactstrap";
import Select from "react-select";
import { resetSession, getAllFinacUsersAction } from "../../../../redux/auth";
import {
  AssignClientsToUserPayloadType,
  GetAllFinacUserPayloadType,
} from "../../../../commonTypes/authTypes";
import "./AssignGroupTwo.scss";
import useDebounce from "../../../../customHooks/useDebounce";
import {
  assignUsersToGroupAction,
  getAllUserGroupsAction,
  getAssignedUsersToGroupAction,
  resetUserManagementError,
  resetUserManagementSuccess,
} from "../../../../redux/userManagement";
import { UserGrouptype } from "../../../../redux/userManagement/userManagementTypes";
import {
  assignGroupToUserType,
  GetAllUserGroupPayloadType,
  GetAllUsersToGroupDetailsPayloadType,
  GetSingleUserGroupDetailsType,
} from "../../../../commonTypes/userManagementTypes";

type AppProps = {
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  clientList: ClientType[] | [];
  userList: UserType[] | [];
  finacUsersList: any;
  userGroupList: [] | UserGrouptype[];
  assignedClientsToUserList: AssignedClientsToUserType[] | [];
  assignedUsersToGroupList: [] | number[];
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => void;
  dispatchGetAllFinacUsersAction: (
    data: GetAllFinacUserPayloadType
  ) => void | undefined;
  dispatchAssignClientsToUserAction: (
    data: AssignClientsToUserPayloadType
  ) => void;
  dispatchResetSession: () => void;
  dispatchGetAssignedUsersToGroupAction: (
    data: GetAllUsersToGroupDetailsPayloadType
  ) => void;
  dispatchAssignUsersToGroupAction: (data: assignGroupToUserType) => void;
  dispatchResetUserManagementError: () => void;
  dispatchResetUserManagementSuccess: () => void;
  userGroupCount: number | string | any;
};

type clientListType = {
  value: number | undefined;
  label: string | undefined;
};

type userListType = {
  value: number | undefined;
  label: string | undefined;
};

const AssignGroupToUser = ({
  token,
  fetching,
  success,
  error,
  statusCode,
  userGroupList,
  finacUsersList,
  userGroupCount,
  assignedUsersToGroupList,
  dispatchGetAssignedUsersToGroupAction,
  dispatchGetAllUserGroupsAction,
  dispatchGetAllFinacUsersAction,
  dispatchAssignUsersToGroupAction,
  dispatchResetSession,
  dispatchResetUserManagementError,
  dispatchResetUserManagementSuccess,
}: AppProps) => {
  const [groupValue, setGroupValue] = useState<number | undefined>(undefined);
  const [userCodeList, setUserCodeList] = useState<number[] | []>([]);
  const [finalClientList, setFinalClientList] = useState<clientListType[] | []>(
    []
  );
  const [finalUserGroupList, setFinalUserGroupList] = useState<
    userListType[] | []
  >([]);
  const [groupSelected, setGroupSelected] = useState<any>({
    value: null,
    label: "Select Group...",
  });
  const [filteredUserList, setFilteredUserList] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(20);
  const [offset, setoffset] = useState(0);
  const [text, setText] = useState("");
  const [loadCondition, setLoadCondition] = useState(true);

  useEffect(() => {
    if (token) {
      if (offset <= +userGroupCount) {
        let finalUserData = {
          token,
          offset,
          limit,
          search_term: text,
        };
        dispatchGetAllUserGroupsAction(finalUserData);
      }
    }
  }, [offset])

  useEffect(()=>{
    const finacUserData = {
      token,
      user_type: "all",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finacUserData);
 
  dispatchResetUserManagementError();
  dispatchResetUserManagementSuccess();
  },[])

  const fetchNewData = (search: string) => {
    let finalUserData = {
      token,
      offset,
      limit,
      search_term: text,
    };
    dispatchGetAllUserGroupsAction(finalUserData);
  };

  useDebounce(
    () => {
      if(text.length>0){
        fetchNewData(text);
      } 
    },
    500,
    [text]
  );

  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      let finalClientData = finacUsersList?.data?.map((user: any) => {
        return {
          value: user.user_id,
          label: `${user.first_name} ${user.last_name} (${user.email})`,
        };
      });
      setFinalClientList(finalClientData);
    }
  }, [finacUsersList]);

  useEffect(() => {
    if (userGroupList?.length > 0) {
      if (offset <= +userGroupCount) {
        let finalGroupData = userGroupList?.map((group: any) => {
          return {
            value: group.group_id,
            label: group.group_name,
          };
        });

        if (offset > 0) {
          setFinalUserGroupList([...finalUserGroupList, ...finalGroupData]);
        } else {
          setFinalUserGroupList([...finalGroupData]);
        }
      }
    }
  }, [userGroupList]);

  useEffect(() => {
    let alreadyAssignedUsers: any[] = [];
    assignedUsersToGroupList?.length > 0 &&
      assignedUsersToGroupList?.map((client: any) =>
        alreadyAssignedUsers?.push(client)
      );
    setUserCodeList(alreadyAssignedUsers);
  }, [assignedUsersToGroupList]);

  const renderUserList = () => {
    let finacUsersList =
      searchValue?.length > 0
        ? filteredUserList?.map((client: any) => {
            let assignedCode = userCodeList?.find(
              (oldCode) => oldCode === client?.value
            );
            return (
              <li key={client.value}>
                <Input
                  type="checkbox"
                  onChange={() => handleAddUsers(client?.value)}
                  checked={!!assignedCode}
                />
                {client?.label}
              </li>
            );
          })
        : finalClientList.map((client: any) => {
            let assignedCode = userCodeList?.find(
              (oldCode) => oldCode === client?.value
            );
            return (
              <li key={client.value}>
                <Input
                  type="checkbox"
                  onChange={() => handleAddUsers(client?.value)}
                  checked={!!assignedCode}
                />
                {client?.label}
              </li>
            );
          });

    return finacUsersList;
  };

  const handleChangeGroup = (group: any) => {
    setGroupSelected(group);
    setGroupValue(group?.value);
    if (group && token) {
      let finalData = {
        group_id: group?.value,
        token,
      };
      dispatchGetAssignedUsersToGroupAction(finalData);
    }
  };

  const handleSearchUser = (event: any) => {
    let value = event.target.value;
    if (value?.length > 0) {
      setFilteredUserList([]);
      let searchResult = [...finalClientList];
      searchResult = searchResult.filter(
        (data: any) =>
          JSON.stringify(data).toLowerCase().search(value.toLowerCase()) !== -1
      );

      setFilteredUserList(searchResult);
      setSearchValue(value);
    } else {
      setSearchValue("");
      getAllUsers();
    }
  };

  const getAllUsers = () => {
    dispatchGetAllFinacUsersAction({ token, user_type: "all" , status:1});
  };

  const handleAddUsers = (userCode: number) => {
    let oldUserCodeList = [...userCodeList];
    let newUserCodeList = [];
    let isClientCode = oldUserCodeList?.find(
      (userCodeId) => userCodeId === userCode
    );

    if (isClientCode) {
      newUserCodeList = oldUserCodeList?.filter((code) => code !== userCode);
    } else {
      newUserCodeList = [...oldUserCodeList, userCode];
    }

    setUserCodeList(newUserCodeList);
  };

  const handleAssignGroup = () => {
    let finalData = {
      group_id: groupValue,
      user_id: userCodeList,
      token,
    };
    dispatchAssignUsersToGroupAction(finalData);
  };

  const handleResetData = () => {
    setGroupSelected({
      value: null,
      label: "Select User...",
    });
    setGroupValue(undefined);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserManagementError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Users Assigned To Group Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetUserManagementSuccess();
            dispatchResetUserManagementError();
            handleResetData();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };
  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setoffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);

  return (
    <div className="row">
      <div className="col-md-12">
        <CommonHeader title="Assign Group to Users" />
      </div>
      <div className="col-md-5 mt-3">
        <h3 className="mb-3">Choose Group</h3>
        <Select
          value={groupSelected}
          cacheOptions
          options={finalUserGroupList}
          onChange={handleChangeGroup}
          onMenuScrollToBottom={(e: any) => checkBottom(e)}
          onInputChange={(e: string) => {
            setLoadCondition(false);
            setText(e);
            setoffset(0);
          }}
          onMenuClose={onMenuClose}
          isLoading={!loadCondition && fetching}
        />
      </div>
      <div className="col-md-7 mt-3">
        <h3 className="mb-3">Choose Users</h3>
        <div className="form-group">
          <div className="d-flex justify-content-start">
            <input
              type="text"
              className="form-control search-client-input w-50"
              placeholder="Search User..."
              value={searchValue}
              onChange={(e) => handleSearchUser(e)}
              disabled={!groupValue}
            />
          </div>
        </div>
        <div className="client-container">
          {groupValue ? (
            <ul className="column-list">{renderUserList()}</ul>
          ) : (
            <span>Please Choose Group...</span>
          )}
        </div>
        <button
          className="btn btn-primary mt-4 pointer"
          onClick={handleAssignGroup}
          style={{ width: "50%" }}
          disabled={!groupValue}
        >
          Assign User To Group
        </button>
      </div>
      {handleErrorModal()}
      {loadCondition && fetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.userManagement.fetching,
  statusCode: state.userManagement.statusCode,
  userGroupList: state.userManagement.userGroupList,
  finacUsersList: state.auth.finacUsersList,
  success: state.userManagement.success,
  error: state.userManagement.error,
  assignedClientsToUserList: state.auth.assignedClientsToUserList,
  assignedUsersToGroupList: state.userManagement.assignedUsersToGroupList,
  userGroupCount: state.userManagement.userGroupCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) =>
    dispatch(getAllUserGroupsAction(data)),
  dispatchAssignUsersToGroupAction: (data: assignGroupToUserType) =>
    dispatch(assignUsersToGroupAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAssignedUsersToGroupAction: (
    data: GetAllUsersToGroupDetailsPayloadType
  ) => dispatch(getAssignedUsersToGroupAction(data)),
  dispatchResetUserManagementError: () => dispatch(resetUserManagementError()),
  dispatchResetUserManagementSuccess: () =>
    dispatch(resetUserManagementSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignGroupToUser);
